// extracted by mini-css-extract-plugin
export default {"baseModal":"baseModal-PZBfW","buttonsModal":"buttonsModal-Rv6Pj","button":"button-eggKp"};